interface RightArrowProps {
    className?: string;
}

export default function RightArrow({ className = "" }: RightArrowProps) {
    return (
        <span
            className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-engage-100 text-engage-600 ${className}`}
            aria-hidden
        >
            <svg
                className="h-4 w-4"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M10 7l5 5-5 5" />
            </svg>
        </span>
    );
}
